import { render } from "./EDITCardG.vue?vue&type=template&id=70ed3814&scoped=true"
import script from "./EDITCardG.vue?vue&type=script&lang=js"
export * from "./EDITCardG.vue?vue&type=script&lang=js"

import "./EDITCardG.vue?vue&type=style&index=0&id=70ed3814&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ed3814"]])

export default __exports__